import { useEffect } from 'react';
import LostCargoReturnDetailSearchProductList from './LostCargoReturnDetailSearchProductList';
import { SCUIContent } from '../../../atomic/organisms';
import { useLocation } from 'react-router-dom';
import { useLostCargoReturnDetailPage } from '../context/LostCargoReturnDetailPageContext';
import { SCUIBreadCrumb } from '../../../atomic/molecules';
import { useTranslation } from 'react-i18next';
import { Grid, CircularProgress, Box } from '@mui/material';
import { LCRD } from '../lostCargoReturnDetailPage.classes';

function LostCargoReturnDetailPageContent() {
    const { t } = useTranslation();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const paramsObj: Record<string, string> = {};
    query.forEach((value, key) => {
        paramsObj[key.toLowerCase()] = value;
    });
    const returnId = paramsObj['returnid'];
    const customerId = paramsObj['customerid'];
    const { returnDetailData, setReturnDetailData, GetReturnDetailByReturnIdForLostCargo, loading } =
        useLostCargoReturnDetailPage();
    useEffect(() => {
        if (returnId && customerId) {
            let req = { returnId, customerId };
            GetReturnDetailByReturnIdForLostCargo(req);
        } else {
            setReturnDetailData([]);
        }
    }, [returnId, customerId]);

    if (loading) {
        return (
            <SCUIContent>
                <Box className={LCRD.page}>
                    <Grid
                        className={LCRD.loadingSection}
                        container
                        style={{
                            height: 'calc(100vh - 200px)',
                            width: '100%',
                            margin: 0,
                            padding: 0,
                            marginTop: '-50px',
                        }}
                        alignItems="center"
                        justifyContent="center"
                        >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                height: '100%',
                            }}
                        >
                            <CircularProgress size={80} />
                        </div>
                    </Grid>
                </Box>
            </SCUIContent>
        );
    }

    return (
        <SCUIContent>
            <Box className={LCRD.page}>
            <Grid style={{ margin: '0rem' }}>
                <div className={LCRD.breadcrumbWrap} style={{ marginLeft: '1.5rem' }}>
                    <SCUIBreadCrumb
                        title={t('lostCargoReturnPageBuilder.lostCargoReturnDetail')}
                        componentLink={'lost-cargo-return-page'}
                    />
                </div>
                {returnDetailData && returnDetailData?.productDetailModels?.length > 0 ? (
                    <LostCargoReturnDetailSearchProductList />
                ) : (
                    <div className={LCRD.emptyStateMessage}>{t('general.noDataFound')}</div>
                )}
            </Grid>
            </Box>
        </SCUIContent>
    );
}

export default LostCargoReturnDetailPageContent;
